/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'info': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" d="M7.982 5.849A1.506 1.506 0 016.49 4.338c0-.836.675-1.511 1.493-1.511a1.51 1.51 0 011.511 1.51 1.51 1.51 0 01-1.51 1.512zm1.28 6.595a.744.744 0 01-.729.73H7.431a.744.744 0 01-.729-.73V7.787c0-.41.338-.73.73-.73h1.101c.391 0 .73.339.73.73v4.657zM8 0a7.99 7.99 0 00-8 8c0 4.427 3.573 8 8 8s8-3.573 8-8-3.573-8-8-8z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/info.js